import { stringToAsciiCode } from '@vfit/shared/themes';
import * as S from '../../select.style';
import { IList } from './list.models';

export const List = ({
  filteredItems,
  isMobile,
  innerRef,
  onSelect,
  variant,
  onRequestExit,
  onLoopToInput,
  onClose,
}: IList) => (
  <>
    {filteredItems.map((item, index) => (
      <S.Li
        id={stringToAsciiCode(item)}
        key={stringToAsciiCode(item)}
        onClick={(e) => {
          if (!isMobile) {
            e.preventDefault();
          } else {
            onSelect(e);
          }
        }}
        onPointerDown={(e) => {
          if (isMobile) {
            e.preventDefault();
          } else {
            onSelect(e);
          }
        }}
        role="option"
        aria-selected={innerRef.current?.value === item}
        value={item}
        variant={variant}
        tabIndex={0}
        onKeyDown={(e) => {
          const isLastItem = index === filteredItems.length - 1;
          const isFirstItem = index === 0;

          if (e.key === 'Tab') {
            onClose && onClose();
            return;
          }

          if (e.key === 'ArrowDown') {
            e.preventDefault();
            const next = (e.currentTarget as HTMLElement).nextElementSibling as HTMLElement;
            next?.focus();
          }

          if (e.key === 'ArrowUp') {
            e.preventDefault();
            const prev = (e.currentTarget as HTMLElement).previousElementSibling as HTMLElement;
            if (prev) {
              prev.focus();
            } else {
              onLoopToInput && onLoopToInput();
            }
          }

          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            (e.currentTarget as any).click();
          }
        }}
      >
        {item}
      </S.Li>
    ))}
  </>
);

